import { customersApi } from '@texas/api/endpoints/customersApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useCallback, useEffect } from 'react';
import { customerEvents } from '../../customer/events';
import { useSignalSubscriptionEvents } from '../../shared/hooks/useSignalSubscriptionEvents';
import { useCustomersDirectoryFilters } from './useCustomersDirectoryFilters';

const customerDirectoryEvents = [
  customerEvents.brandCreated,
  customerEvents.brandUpdated,
];

export function useCustomersDirectoryController() {
  const { searchQuery, ...filterActions } = useCustomersDirectoryFilters();
  const {
    data: result,
    error,
    loading,
    refetch,
  } = useApiResource(customersApi.search);

  const refetchCustomers = useCallback(() => {
    refetch(searchQuery);
  }, [refetch, searchQuery]);

  useEffect(() => {
    refetchCustomers();
  }, [refetchCustomers]);

  useSignalSubscriptionEvents({
    signalEvents: customerDirectoryEvents,
    triggerOnEvent: refetchCustomers,
  });

  const totalItems = result?.totalItems ?? 0;
  const firstItem =
    totalItems === 0 ? 0 : (searchQuery.page - 1) * searchQuery.pageSize + 1;
  const lastItem = Math.min(
    searchQuery.page * searchQuery.pageSize,
    totalItems,
  );

  return {
    customers: result?.items ?? [],
    error,
    firstItem,
    includeArchived: searchQuery.includeArchived,
    lastItem,
    loading,
    page: searchQuery.page,
    pageSize: searchQuery.pageSize,
    searchTerm: searchQuery.searchTerm,
    selectedCustomerType: searchQuery.type,
    selectedCurrentUserRole: searchQuery.currentUserRole?.userType,
    showAssignedToCurrentUser: searchQuery.assignedToCurrentUser,
    sortBy: searchQuery.sortBy,
    sortDesc: searchQuery.sortDesc,
    totalItems,
    ...filterActions,
  };
}
